import dayjs from 'dayjs';

import { ModalOperationProps } from './modal-operation.types';
import { CancelOperationType, RenewalOperationType } from '../operations/operations-hooks';
import {
	AssemblyOperationResponse,
	PreformOperationResponse,
	ProductOperationDomain,
	RubberOperationResponse,
} from '@/shared/state/api/swagger';

import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	chakra,
	ModalFooter,
	Button,
} from '@chakra-ui-kraud/react';
import { DatePicker, Select } from 'antd';

import styles from './modal-operation.module.scss';
import { DEFAULT_YEAR_FORMAT } from '@/shared';
import { SetStateAction, Dispatch } from 'react';

type BaseOperation =
	| ProductOperationDomain
	| RubberOperationResponse
	| PreformOperationResponse
	| AssemblyOperationResponse;

export const ModalOperation = <T extends BaseOperation = BaseOperation>({
	variant,
	data,
	setData,
	employee,
	onSubmit,
}: ModalOperationProps<T>) => {
	const setCancelData = setData as Dispatch<SetStateAction<CancelOperationType<T>>>;
	const setRenewalData = setData as Dispatch<SetStateAction<RenewalOperationType<T>>>;

	const handleClose = () => {
		if (variant === 'cancel') {
			setCancelData((prev) => ({ ...prev, isModalOpen: false }));
		} else {
			setRenewalData((prev) => ({ ...prev, isModalOpen: false }));
		}
	};

	return (
		<Modal size={variant === 'renewal' ? 'lg' : 'md'} isOpen={data.isModalOpen} isCentered onClose={handleClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{variant === 'cancel' ? 'Отмена операции' : 'Возобновление операции'}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<chakra.div display="flex" flexDirection="column" gap="10px">
						<chakra.div mb="5px">
							{variant === 'cancel'
								? 'Выберите ответственного за отмену операции:'
								: 'Возобновление операции:'}
							<span style={{ fontWeight: '500' }}>
								{` ${data.operation?.step_id} ${data.operation?.name}`}{' '}
							</span>
						</chakra.div>
						{variant === 'cancel' && (
							<chakra.div display="flex" flexDirection="column" gap="10px">
								<Select
									tabIndex={7}
									filterOption={(input, option) =>
										(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
									}
									allowClear
									showSearch
									autoFocus={false}
									placeholder="Выберите ФИО"
									value={(data as CancelOperationType<T>).closingEmployeeFio}
									onSelect={(e) => {
										setCancelData((prev) => {
											return {
												...prev,
												closingEmployeeFio: employee?.find((el) => el.value === e)?.label ?? '',
											};
										});
									}}
									options={employee}
									style={{
										width: '100%',
										borderRadius: 'var(--chakra-radii-base)',
										border: '1px solid #E2E8F0',
									}}
									dropdownStyle={{ zIndex: 10000 }}
									onClear={() => {
										setCancelData((prev) => {
											return {
												...prev,
												closingEmployeeFio: '',
											};
										});
									}}
								/>
								<chakra.div display="flex" justifyContent="space-between" gap="10px">
									<span>Дата отмены операции:</span>
									<DatePicker
										// status={error ? 'error' : ''}
										onChange={(date) =>
											setCancelData((prev) => {
												return { ...prev, closingDate: dayjs(date).format() };
											})
										}
										format={DEFAULT_YEAR_FORMAT}
										defaultValue={dayjs()}
										name={'cancel_operation_date'}
										dropdownClassName={styles['calendar-dropdown']}
									/>
								</chakra.div>
							</chakra.div>
						)}
					</chakra.div>
				</ModalBody>
				<ModalFooter justifyContent={variant === 'renewal' ? 'space-between' : 'flex-end'}>
					<Button variant="ghost" colorScheme="tertiary" onClick={handleClose}>
						{variant === 'cancel' ? 'Назад' : 'Отменить возобновление'}
					</Button>
					<Button
						isDisabled={variant === 'cancel' ? !(data as CancelOperationType<T>).closingEmployeeFio : false}
						variant={'solid'}
						mr={variant === 'cancel' ? 3 : 0}
						onClick={onSubmit}
					>
						{variant === 'cancel' ? 'Отменить операцию' : 'Возобновить операцию'}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
